export const data = {
    name: "Frac Info",
    layout: [],
};
export default data;